import { handleActions } from 'redux-actions';

import reducersUtils from 'state/utils';
import initialState from 'state/addresses/initial.state';
import actions from 'state/addresses/actionCreators';

const addresses = handleActions(
  {
    [reducersUtils.RESET_ORDER_STATE]: (state) => ({
      ...initialState,
      loadedAddresses: { ...state.loadedAddresses },
    }),
    [actions.setLoadedAddresses]: (
      state,
      { payload: { data, next, count } }
    ) => ({
      ...state,
      loadedAddresses: {
        data,
        next,
        count,
      },
    }),
    [actions.setLoadedVenuesOfInterest]: (state, { payload: { venues } }) => ({
      ...state,
      loadedPointsOfInterest: {
        venues,
      },
    }),

    [actions.setLoadedAddressesOfInterest]: (
      state,
      { payload: { addresses } }
    ) => ({
      ...state,
      loadedPointsOfInterest: {
        addresses,
      },
    }),
    [actions.clearVenuesOfInterest]: (state) => ({
      ...state,
      loadedPointsOfInterest: {
        venues: [],
      },
    }),
    [actions.clearAddressesOfInterest]: (state) => ({
      ...state,
      loadedPointsOfInterest: {
        addresses: [],
      },
    }),
    [actions.setCityData]: (state, { payload: { cityData } }) => ({
      ...state,
      cityData,
    }),
  },
  initialState
);

export default addresses;
